import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './NormalizationContainer.scss';

const ROW_NAME = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'];

class NormalizationViewDiluentVolumeList extends Component {
  shouldComponentUpdate(nextProps) {
    const {normalizationState: oldNormalizationState} = this.props;
    const {csvData: oldCsvData, previewData: oldPreviewData} = oldNormalizationState;

    const {normalizationState} = nextProps;
    const {csvData, previewData} = normalizationState;

    if (oldPreviewData !== previewData) {
      return true;
    }

    if (oldCsvData !== csvData) {
      return true;
    }

    return false;
  }

  createTableData() {
    const {normalizationState} = this.props;
    const {previewData} = normalizationState;

    const rows = [];

    // generate table content
    for (let row = 0; row < previewData.length; row += 1) {
      rows.push(
        <tr key={`row-${row}`}>
          <td>{`${ROW_NAME[previewData[row].row]}${previewData[row].col + 1}`}</td>
          <td>{previewData[row].diluentVol}</td>
        </tr>,
      );
    }

    return rows;
  }

  render() {
    const {normalizationState} = this.props;
    const {csvData} = normalizationState;

    const tableData = this.createTableData();

    return (
      <div className="volume-list-container">
        <div className="title-section">Volume List</div>
        <div className={`volume-list-table-section${csvData.length === 0 ? '-empty' : ''}`}>
          <table className="table">
            <thead>
              <tr>
                <td className="table-header-title">Well</td>
                <td className="table-header-title">Diluent Volume (µL)</td>
              </tr>
            </thead>
            <tbody>{tableData}</tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default NormalizationViewDiluentVolumeList;

NormalizationViewDiluentVolumeList.propTypes = {
  normalizationState: PropTypes.any.isRequired,
};
